export const BLACKLISTED_COMPANIES_FOR_JUNE_SO = [
  "snackmagic",
  "vinsol",
  "bystadium",
  "stadium",
  "swagmagic",
  "superiordishes",
];
